import Image from "next/image";
import {
  AspectRatio,
  Box,
  List,
  ListItem,
  ListIcon,
  Stack,
  Text,
  Flex,
} from "@chakra-ui/react";
import { FaCheck } from "@onemind-services-llc/react-icons-ng/fa";
import ServicesBanner from "public/automation/servicesBanner.svg";
import { SERVICES_LIST } from "./constants";
import { SectionDivider } from "app/components/shared/SectionDivider";

const Services = () => {
  return (
    <Stack data-cy="section-services">
      <SectionDivider
        label={"Network Automation Professional Services"}
        padding="0 2rem"
      />
      <Stack
        alignItems={"center"}
        direction={{ base: "column", md: "row" }}
        spacing={6}
        data-cy="section-services"
      >
        <AspectRatio
          position={"relative"}
          ratio={1}
          width={{ base: "full", sm: "400px" }}
        >
          <Image
            alt={"Service Banner"}
            title={"Service Banner"}
            blurDataURL={
              "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mP8/wcAAwAB/epARQABAAA//w6wAAAAAElFTkSuQmCC"
            }
            fill
            placeholder="blur"
            sizes="(max-width: 400px) 100vw, 400px"
            src={ServicesBanner}
            style={{ objectFit: "contain" }}
          />
        </AspectRatio>
        <List spacing={2}>
          {SERVICES_LIST.map((service, index) => {
            return (
              <ListItem key={index} role="group">
                <Flex gap={2}>
                  <ListIcon
                    as={FaCheck}
                    color="brand.300"
                    fontSize={{ base: "16px", sm: "18px" }}
                  />
                  <Box>
                    {service.title && (
                      <Text fontWeight={650} as={"span"}>
                        {service.title}{" "}
                      </Text>
                    )}
                    <Text as={"span"}>{service.content}</Text>
                  </Box>
                </Flex>
              </ListItem>
            );
          })}
        </List>
      </Stack>
    </Stack>
  );
};

export default Services;
